"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const tinymce_react_1 = require("@tinymce/tinymce-react");
require("tinymce/tinymce");
require("tinymce/icons/default");
require("tinymce/themes/silver");
require("tinymce/models/dom");
require("tinymce/plugins/advlist");
require("tinymce/plugins/autolink");
require("tinymce/plugins/lists");
require("tinymce/plugins/link");
require("tinymce/plugins/charmap");
require("tinymce/plugins/preview");
require("tinymce/plugins/anchor");
require("tinymce/plugins/searchreplace");
require("tinymce/plugins/visualblocks");
require("tinymce/plugins/code");
require("tinymce/plugins/insertdatetime");
require("tinymce/plugins/table");
require("tinymce/plugins/wordcount");
const editorStyle_1 = __importDefault(require("../../hooks/editorStyle"));
const CustomTableEditor = ({ defaultRows, defaultCols, defaultBackgroundColor, defaultBorderColor, defaultCellPadding, defaultTableWidth, defaultFontSize, defaultFontFamily, editorWidth, editorHeight, defaultX, defaultY, customContentStyle, defaultValue, editorValue: propEditorValue, setEditorValue: propSetEditorValue, }) => {
    const [internalEditorValue, setInternalEditorValue] = (0, react_1.useState)('');
    const currentEditorValue = propEditorValue !== null && propEditorValue !== void 0 ? propEditorValue : internalEditorValue;
    const currentSetEditorValue = propSetEditorValue || setInternalEditorValue;
    const wrapperId = "my-editor-wrapper";
    const generateDefaultTable = () => {
        var _a;
        if (!defaultRows || !defaultCols)
            return "";
        let tableHTML = `<table style="border-collapse: collapse; width: ${defaultTableWidth || "100%"}; background-color: ${defaultBackgroundColor || "#ffffff"};">`;
        for (let row = 0; row < defaultRows; row++) {
            tableHTML += "<tr>";
            if (defaultValue) {
                for (let col = 0; col < defaultCols; col++) {
                    let cellContent = ((_a = defaultValue[row]) === null || _a === void 0 ? void 0 : _a[col]) || "";
                    if (typeof cellContent === "string" && cellContent.includes("<img")) {
                        cellContent = cellContent.replace(/<img(?![^>]*\bwidth=)(?![^>]*\bheight=)([^>]*)>/g, `<img$1 width="300" height="300" style="max-width:100%;height:auto;" />`);
                    }
                    tableHTML += `<td style="border: 1px solid ${defaultBorderColor || "#d9d9d9"}; padding: ${defaultCellPadding || "6px"};">${cellContent}</td>`;
                }
            }
            tableHTML += "</tr>";
        }
        tableHTML += "</table>";
        return tableHTML;
    };
    const getContentStyle = () => {
        if (customContentStyle)
            return customContentStyle;
        let style = `body { margin: 0; }`;
        if (defaultFontFamily || defaultFontSize) {
            style += `
        body {
          ${defaultFontFamily ? `font-family: ${defaultFontFamily};` : ""}
          ${defaultFontSize ? `font-size: ${defaultFontSize};` : ""}
        }
      `;
        }
        if (defaultTableWidth || defaultBackgroundColor || defaultBorderColor || defaultCellPadding) {
            style += `
        table { border-collapse: collapse; width: ${defaultTableWidth || "auto"}; background-color: ${defaultBackgroundColor || "transparent"}; }
        td, th { ${defaultBorderColor ? `border: 1px solid ${defaultBorderColor};` : ""} ${defaultCellPadding ? `padding: ${defaultCellPadding};` : ""} }
      `;
        }
        return style;
    };
    (0, react_1.useEffect)(() => {
        if ((!currentEditorValue || currentEditorValue.trim() === "") && defaultRows && defaultCols) {
            currentSetEditorValue(generateDefaultTable());
        }
    }, [currentEditorValue, defaultRows, defaultCols]);
    (0, editorStyle_1.default)(wrapperId);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { id: wrapperId, style: { width: "100%", height: "100%" }, children: (0, jsx_runtime_1.jsx)(tinymce_react_1.Editor, { licenseKey: "gpl", value: currentEditorValue, onEditorChange: (content) => currentSetEditorValue(content), init: {
                    base_url: "/tinymce",
                    suffix: ".min",
                    height: "100%",
                    width: "100%",
                    menubar: false,
                    branding: false,
                    statusbar: false,
                    inline: true,
                    fixed_toolbar_container: "#myToolbar",
                    plugins: ["table"],
                    toolbar: "table insertDefaultTable | tableprops cellprops rowprops colprops | fontselect fontsizeselect | bold italic underline | forecolor backcolor | alignleft aligncenter alignright",
                    content_style: getContentStyle(),
                } }) }) }));
};
exports.default = CustomTableEditor;
